// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
  background-color: #f5f5f5;
}

.not-found-title {
  font-size: 8rem;
  font-weight: 700;
  margin: 0;
  color: #6c5ce7;
}

.not-found-message {
  font-size: 1.5rem;
  margin: 20px 0 10px;
  color: #333;
}

.not-found-description {
  font-size: 1rem;
  color: #696969;
  margin-bottom: 30px;
}

.back-home-link {
  padding: 10px 20px;
  background-color: #6c5ce7;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.back-home-link:hover {
  background-color: #5a4cd9;
}`, "",{"version":3,"sources":["webpack://./src/pages/404/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".not-found-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n.not-found-title {\n  font-size: 8rem;\n  font-weight: 700;\n  margin: 0;\n  color: #6c5ce7;\n}\n\n.not-found-message {\n  font-size: 1.5rem;\n  margin: 20px 0 10px;\n  color: #333;\n}\n\n.not-found-description {\n  font-size: 1rem;\n  color: #696969;\n  margin-bottom: 30px;\n}\n\n.back-home-link {\n  padding: 10px 20px;\n  background-color: #6c5ce7;\n  color: white;\n  text-decoration: none;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.back-home-link:hover {\n  background-color: #5a4cd9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
